import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ServiceBookService } from '../../../../services/serviceBook.service';
@Component({
  components: {}
})
class ModalBuyServiceBook extends Vue {

  @Prop({ default: [], type: Array })
  serviceBookProduct: boolean;


  constructor() {
    super();

  }




  navigateTo(url)
  {
    let currentUrl = window.location.origin;
    //console.log(currentUrl);

    currentUrl = currentUrl.replace('https://', 'https--');
    currentUrl = currentUrl.replace('http://', 'http--');
    currentUrl = currentUrl.replace('.', '_');
    currentUrl = currentUrl.replace(':', '----');

    // Get the current URL parameters
    let params = new URLSearchParams(url.split('?')[1]);

    // Add a new parameter
    params.set('utm_source', currentUrl);

    // Construct a new URL with the modified parameters
    let newUrl = `${url.split('?')[0]}?${params.toString()}`;



    // Use the new URL as needed
    console.log(newUrl);

    window.open(newUrl,'_parent');
  }
}
export default ModalBuyServiceBook



// WEBPACK FOOTER //
// ./src/containers/home/components/modal-buy-servicebook/index.ts